(function () {
    'use strict';

    angular
        .module('app')
        .factory('savedSearchService', savedSearchService);

    savedSearchService.$inject = ['$http', '$localStorage', '$q', 'breadCrumbService', 'loginService', 'searchService'];

    function savedSearchService($http, $localStorage, $q, breadCrumbService, loginService, searchService) {
        var service = {
            currentItem: {},
            getDefinitions: getDefinitions,
            getData: getData,
            getCount: getCount,
            definitions: [],
            currentDefinitions: [],
            previous: previous,
            next: next,
            currentIndex: 0,
            close: close,
            gotoPage: gotoPage,
            resetActive: resetActive,
            addSavedSearch: addSavedSearch,
            addSavedSearchFromSavedSearch: addSavedSearchFromSavedSearch,
            editSavedSearch: editSavedSearch,
            deleteSavedSearch: deleteSavedSearch,
            getOperations: getOperations
        };

        return service;

        // Saved Search Service - getOperations
        function getOperations(id) {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/Api/savedsearch/operations/' + encodeURIComponent(id)).then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getSavedSearchOperations(id) {
            var deferred = $q.defer();
            var searchActions = [" ", " [OR] ", " [AND] ", ""];
            service.getOperations(id).then(function (data) {
                var previousSearchCriteria = "";
                angular.forEach(data, function (operationList, key) {
                    //handle SAF
                    if (operationList.searchAction == 3) {
                        operationList.searchCriteria = [{ schemaID: "__SEARCH_ALL_FIELDS__", valueStr: operationList.searchCriteria[0].valueStr }]
                    }
                    var operations = searchService.parseOperations(operationList.searchCriteria);
                    if (operationList.searchCriteria.length > 0) {
                        previousSearchCriteria = previousSearchCriteria + searchActions[operationList.searchAction] + searchService.parseOperationsToString(operations);
                    }
                });
                deferred.resolve(previousSearchCriteria);
            });
            return deferred.promise;
        }


        // Saved Search Service - getDefinitions
        function getDefinitions(force) {
            var deferred = $q.defer();
            if (service.definitions.length == 0 || force) {
                var promise = $http.get("../Synergis.WebApi/Api/savedSearch/definitions").then(function (response) {
                    service.definitions = [];
                    angular.forEach(response.data, function (item, index) {
                        item.active = false;
                        if (item.name != "___LAST_SEARCH___" && item.name != "___ALT_LAST_SEARCH___") {
                            service.definitions.push(item);
                        }
                    })
                    service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
                    deferred.resolve(service.definitions);
                })

            }
            else {
                deferred.resolve(service.definitions);
            }
            return deferred.promise;
        }

        // Saved Search Service - getData
        function getData(skip, take, totalRecords, sort, sortDirection, countOperation, resultType, columns) {
            var deferred = $q.defer();
            if (Object.keys(service.currentItem).length == 0) {
                if ($localStorage.userSettings["savedSearchServiceItem"] != undefined) {
                    service.currentItem = $localStorage.userSettings["savedSearchServiceItem"];
                }
                else {
                    throw "No search item available";
                }
            }
            service.currentItem.take = take;
            service.currentItem.skip = skip;

            breadCrumbService.category = loginService.resourceStrings["SAVED_SEARCH"];

            getSavedSearchOperations(service.currentItem.id).then(function (value) {
                breadCrumbService.details = service.currentItem.name + '/' + value;
                breadCrumbService.node = null;
            });

            //save the current into local storage
            $localStorage.userSettings["savedSearchServiceItem"] = service.currentItem;
            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            //define objects required for call
            var adeptDataTable = { TableDefinition: null, TableRecords: null, RecordCount: totalRecords, Take: take, Skip: skip };
            var searchObject = {
                SavedSearchID: service.currentItem.id,
                UserId: null,
                ColumnSetId: null,
                CountOperation: countOperation,
                AdeptDataTable: adeptDataTable,
                ResultType: resultType,
                Columns: columns,
                Sort: { SortField: sort, SortOrder: sortDirection }
            };
            var request = $http({
                url: '../Synergis.WebApi/Api/savedSearch/documents',
                method: 'POST',
                responseType: responseType,
                data: JSON.stringify(searchObject),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            })

            return { promise: deferred.promise };
        };

        // Saved Search Service - getCount
        function getCount() {
            var deferred = $q.defer();
            service.getData(0, 0, 0, "SCHEMA_S_LONGNAME", 0, true).promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            });
            return deferred.promise;
        }

        // Saved Search Service - gotoPage
        function gotoPage(pageNumber) {
            if (service.currentIndex < pageNumber) {
                service.animationClass = "widget-right";
            }
            else {
                service.animationClass = "widget-left";
            }
            service.currentIndex = pageNumber * 4;
            service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
        }

        // Saved Search Service - next
        function next() {
            service.animationClass = "widget-right";
            service.currentIndex = service.currentIndex + 4;
            service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
        }

        // Saved Search Service - previous
        function previous() {
            service.animationClass = "widget-left";
            service.currentIndex = service.currentIndex - 4;
            service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
        }

        // Saved Search Service - close
        function close() {
            service.currentIndex = 0;
            service.currentDefinitions = [];
            service.definitions = [];
        }



        function addSavedSearch(name, comment) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SavedSearch/SavedSearch';
            $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify({ name: name, comment: comment }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function addSavedSearchFromSavedSearch(name, comment, id) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SavedSearch/SavedSearchFrom';
            url = url.concat("/" + encodeURIComponent(name) + "/" + encodeURIComponent(comment) + "/" + encodeURIComponent(id));
            $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(""),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function editSavedSearch(id, name, comment) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SavedSearch/SavedSearch';
            url = url.concat("/" + encodeURIComponent(id));
            $http({
                url: url,
                method: 'POST',
                data: JSON.stringify({ name: name, comment: comment }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteSavedSearch(id) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SavedSearch/SavedSearch';
            url = url.concat("/" + id);
            $http({
                url: url,
                method: 'DELETE',
                data: JSON.stringify(""),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }


        function resetActive() {
            angular.forEach(service.definitions, function (item) {
                item.active = false;
            });
        }

    }
})();